import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=3c3f534e&scoped=true"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"
import style0 from "./Address.vue?vue&type=style&index=0&id=3c3f534e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3f534e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c3f534e')) {
      api.createRecord('3c3f534e', component.options)
    } else {
      api.reload('3c3f534e', component.options)
    }
    module.hot.accept("./Address.vue?vue&type=template&id=3c3f534e&scoped=true", function () {
      api.rerender('3c3f534e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/address/Address.vue"
export default component.exports